module.exports = __webpack_public_path__ + "static/img/user2.fb2befc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user2.jpg
// module id = 7zXz
// module chunks = 23